import * as React from 'react';
import styled, { css } from 'styled-components';
import { Loader } from '../../../styles/global/css/GlobalLoader';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { Open } from '../../../styles/global/css/Open';
import { FlexDiv } from '../../products/style';
import { BorderColor, SidelyBlack } from '../../../styles/global/css/Utils';

interface ListContainerProps {
	borderTop?: string
}

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    scrollbar-gutter: stable;
`;

const ListContainer = styled.div<ListContainerProps>`
    display: flex;
    flex-direction: row;
    align-items: center;

    border-top: ${p => p.borderTop ?? `1px solid ${BorderColor}`};
    cursor: pointer;
    padding-top: 15px;
    margin-top: 15px;

    justify-content: flex-start;
    width:100%;
    gap:20px;
    padding-left:20px;
    padding-right:20px;
`;

const ListTextCss = css`
    ${DefaultText}
    color: ${SidelyBlack};
    font-weight: 500;
    font-size: 13px;
    width: 100%;
`;

const ListText = styled.p`
    ${ListTextCss}
`;

export const DEFAULT_LINKED_ELEMENT_OPEN_SIZE = 11;

export function ListTitle(props: { isOpen: boolean, label: string, amount?: React.ReactNode, children?: React.ReactNode }): JSX.Element {
	return <ListText>
		<FlexDiv gap='8px'>
			<FlexDiv>{props.label} ({props.amount ?? <Loader width='18px' />})</FlexDiv>
			{props.children}
			<Open isOpen={props.isOpen} size={DEFAULT_LINKED_ELEMENT_OPEN_SIZE} />
		</FlexDiv>
	</ListText>;
}

export {
	Body,
	ListContainer,
	ListText
};
